// extracted by mini-css-extract-plugin
export default {"tabContainer":"PriceTab_tabContainer__5JH5y"};